import { render } from "./SelectMc.vue?vue&type=template&id=c4ca07cc&scoped=true"
import script from "./SelectMc.vue?vue&type=script&lang=js"
export * from "./SelectMc.vue?vue&type=script&lang=js"

import "./SelectMc.vue?vue&type=style&index=0&id=c4ca07cc&scoped=true&lang=css"

import exportComponent from "/Users/fredde/programvara/boove.se/w3.boove.se/w3.boove.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4ca07cc"]])

export default __exports__